var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Telegram Icon",
    clipPath: "url(#clip0_100_901)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.833 3.32247C15.0183 3.24447 15.2212 3.21756 15.4204 3.24456C15.6197 3.27156 15.8081 3.35148 15.966 3.47599C16.1239 3.6005 16.2455 3.76506 16.3183 3.95254C16.391 4.14001 16.4121 4.34355 16.3795 4.54197L14.6785 14.8597C14.5135 15.855 13.4215 16.4257 12.5087 15.93C11.7452 15.5152 10.6112 14.8762 9.59123 14.2095C9.08123 13.8757 7.51898 12.807 7.71098 12.0465C7.87598 11.3962 10.501 8.95272 12.001 7.49997C12.5897 6.92922 12.3212 6.59997 11.626 7.12497C9.89873 8.42847 7.12748 10.4107 6.21098 10.9687C5.40248 11.4607 4.98098 11.5447 4.47698 11.4607C3.55748 11.3077 2.70473 11.0707 2.00873 10.782C1.06823 10.392 1.11398 9.09897 2.00798 8.72247L14.833 3.32247Z",
    fill: "#FEFEFB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/Telegram Icon.21d991dd9c50bb9d98a925bf2da94e09.svg";
export { ForwardRef as ReactComponent };